export const SENTRY_RELEASE: string | undefined = '78b2c88f2c229ef833327fbb0f3b8302f83e6faf';
